/* app/js/src/components/graphics/edit/fields/text-ticker.component.scss */
.cursor-pointer {
  cursor: pointer;
}
* {
  box-sizing: border-box;
}
.row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.row:not(:first-child) {
  margin-top: 24px;
}
.checkbox-label {
  line-height: 32px;
  font-family: "Open Sans";
  font-size: 12px;
  color: #232f3a;
}
.checkbox-input {
  padding: 0 10px 7px 20px;
}
.checkbox-input div {
  position: relative;
  border: 1px solid #e1e6eb;
  width: 14px;
  height: 14px;
  cursor: pointer;
  margin-top: 6px;
  background-color: white;
}
.checkbox-input div svg {
  width: 10px;
  height: 7px;
  position: absolute;
  top: -1px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  fill-opacity: 0;
}
.checkbox-input.active div svg {
  fill-opacity: 1;
}
label {
  color: #7d8fa1;
  font-size: 12px;
  letter-spacing: 0.1px;
  margin-right: 10px;
  margin-left: 20px;
}
.row.speed span {
  color: #7d8fa1;
  margin-left: 8px;
}
.number-input {
  width: 100px;
}
/*# sourceMappingURL=text-ticker.component.css.map */
